export function deepEqual(obj1: unknown, obj2: unknown): boolean {
  if (obj1 === obj2) return true;

  if (obj1 == null || obj2 == null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false;
  }

  if (Array.isArray(obj1)) {
    return (
      Array.isArray(obj2) &&
      obj1.length === obj2.length &&
      obj1.every((item, index) => deepEqual(item, obj2[index]))
    );
  }

  if (Array.isArray(obj2)) return false;

  const o1 = obj1 as Record<string, unknown>;
  const o2 = obj2 as Record<string, unknown>;
  const keys = Object.keys(o1);

  return keys.length === Object.keys(o2).length && keys.every((key) => deepEqual(o1[key], o2[key]));
}
